export default {"src":"/_next/static/media/hand-right.b735ee70.svg","height":251,"width":332,"blurWidth":0,"blurHeight":0};